// extracted by mini-css-extract-plugin
module.exports = {"container":"Form_container__UmUuk","wrap":"Form_wrap__2LLWH","inputWrap":"Form_inputWrap__31IkR","btn":"Form_btn__1uEui"};